import { define, ui } from '@owenscorning/pcb.alpha';

export default define`Related Articles`('0.0.1')({
  view: ui`Modules/Page/CardSet|view`,
  edit: ui`Modules/Page/CardSet`,
});
